module.exports = __webpack_public_path__ + "51b289eccf91d6368129897efaeda949.svg";